import { createSelector } from 'reselect';

import { getStringProp } from '@mews/fp';

import {
    getEnterpriseConfigurationId,
    getEnterpriseDefaultCurrencyCode,
    getEnterpriseDefaultLanguageCode,
} from '../../modules/entities/enterprises/selectors';
import { parentSelector } from '../../selectors/parentSelector';
import { ApplicationState } from '../../types';
import { FeatureFlagServiceView } from './types';

const getFeatureFlagServiceView = createSelector<ApplicationState, ApplicationState, FeatureFlagServiceView>(
    parentSelector,
    (state) => state.views.featureFlagService
);

export const isFeatureFlagServiceScopeLoading = createSelector(getFeatureFlagServiceView, (featureFlagServiceView) =>
    Boolean(featureFlagServiceView.isFeatureFlagScopeLoading)
);

export const getFeatureFlagServiceUserConfiguration = createSelector(
    getStringProp('enterpriseId'),
    getStringProp('hostname'),
    getEnterpriseDefaultCurrencyCode,
    getEnterpriseDefaultLanguageCode,
    getEnterpriseConfigurationId,
    (enterpriseId, hostname, enterpriseDefaultCurrencyCode, enterpriseDefaultLanguageCode, configurationId) => ({
        anonymous: true,
        custom: {
            enterpriseId,
            hostname,
            enterpriseDefaultCurrencyCode,
            enterpriseDefaultLanguageCode,
            ...(configurationId != null ? { configurationId } : {}),
        },
    })
);
